import { BASIC_INITIAL_STATE } from '@usas/ui-web/utils/HttpHelper';

import getOmeMeetEntryData from './GetOmeMeetEntryData';
import postOmeMeetEntryData from './PostOmeMeetEntryData';
import putOmeMeetEntryData from './PutOmeMeetEntryData';
import deleteOmeMeetEntryData from './DeleteOmeMeetEntryData';

const INITIAL_STATE = {
  ...BASIC_INITIAL_STATE,
  selectedMeet: {},
  route: ''
};

const OmeMeetEntryData = {
  INITIAL_STATE,
  getOmeMeetEntryData,
  postOmeMeetEntryData,
  putOmeMeetEntryData,
  deleteOmeMeetEntryData
};

export default OmeMeetEntryData;